import { render, staticRenderFns } from "./PromoModal.vue?vue&type=template&id=618cc36c&scoped=true"
import script from "./PromoModal.vue?vue&type=script&lang=js"
export * from "./PromoModal.vue?vue&type=script&lang=js"
import style0 from "./PromoModal.vue?vue&type=style&index=0&id=618cc36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cc36c",
  null
  
)

export default component.exports